module.exports = __webpack_public_path__ + "components/flag/static/square/cf-26a32e982387a0df4f3d893efcc278ef.svg";